export default {
  START_CLICK: 'Start request COVID19 form',
}
